
 <template>
  <div>
    <el-form ref="form" label-width="150px">
      <el-row class="form-title">账户信息</el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="客户名称">{{detailData.customerName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="合计产生返优惠金额">{{detailData.totalRebateAmount}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="可用金额">{{detailData.balance}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已冻结金额">{{detailData.frozenAmount}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="已用金额">{{detailData.usedAmount}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已过期金额">{{detailData.expiredAmount}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="form-title">
      交易流水
    </el-row>
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="变动类型" prop="type" v-if="activeTab === 'transaction'">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产生年份">
        <el-date-picker
          class="year-picker"
          v-model="form.startYear"
          type="year"
          placeholder="开始年份"
          :picker-options="startPickerOptions"
          value-format="yyyy"
          @change="handleStartChange"/>
        <span class="separator">至</span>
        <el-date-picker
          class="year-picker"
          v-model="form.endYear"
          type="year"
          placeholder="结束年份"
          :picker-options="endPickerOptions"
          value-format="yyyy"
          :disabled="!form.startYear"/>
      </el-form-item>
      <el-form-item label="交易时间" prop="tareWeightTime" v-if="activeTab === 'transaction'">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" v-if="activeTab === 'transaction'" @click="handleExport" class="export-btn">导出</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="年份统计" name="yearStatistics">
        <el-table border :data="tableData" tooltip-effect="light">
          <el-table-column
            prop="year"
            label="产生年份"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="合计金额"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="balanceAmount"
            label="可用金额"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="useAmount"
            label="已用金额"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="frozenAmount"
            label="已冻结金额"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="expiredAmount"
            label="已失效金额"
            :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="交易流水" name="transaction">
        <el-table border :data="tableData" tooltip-effect="light">
          <el-table-column
            prop="code"
            label="流水号"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="变动类型"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="changeAmount"
            label="金额"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="batch"
            label="批次"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="year"
            label="产生年份"
            width="60"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="isEquityFund"
            label="是否权益金"
            width="60"
            :show-overflow-tooltip="true">
             <template slot-scope="scope">{{scope.row.isEquityFund === 0 ? '否' : '是'}}</template>
          </el-table-column>
          <el-table-column
            prop="usePolicyName"
            label="返优惠使用规则"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="tradeTime"
            label="交易时间"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="expiredTime"
            label="到期时间"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="orderNum"
            label="订单号"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="businessNo"
            label="关联单据"
            :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <el-row>
      <el-button @click="handleClose">返 回</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'billDetail',
  data () {
    return {
      rebateAccountId: '',
      form: {
        tareWeightTime: [],
        startYear: '',
        endYear: ''
      },
      typeList: [
        { value: '', label: '全部' },
        { value: 1, label: '增加' },
        { value: 2, label: '下单扣减' },
        { value: 3, label: '手动增加' },
        { value: 4, label: '手动扣减' },
        { value: 5, label: '到期失效' },
        { value: 6, label: '失效释放' },
        { value: 7, label: '退款返还' }
      ],
      activeTab: 'yearStatistics',
      currentYear: new Date().getFullYear(),
      detailData: {},
      tableData: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    startPickerOptions () {
      return {
        disabledDate: (date) => {
          // 禁用未来年份
          const year = date.getFullYear()
          return year > this.currentYear
        }
      }
    },
    endPickerOptions () {
      return {
        disabledDate: (date) => {
          // 禁用未来年份和早于开始年份的年份
          const year = date.getFullYear()
          if (this.form.startYear) {
            return year > this.currentYear || year < parseInt(this.form.startYear)
          }
          return year > this.currentYear
        }
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.queryDetail()
    this.handleSearch()
  },
  methods: {
    ...mapActions(['rebateAccountInfo', 'rebateAccountDetailPage', 'exportRebateAccountDetail', 'getRebateYearStatistics']),
    queryDetail () {
      this.rebateAccountInfo({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
        }
      })
    },
    // 搜索
    handleSearch () {
      const params = {
        rebateAccountId: this.id,
        ...this.listState
      }
      if (this.form.type) params.type = this.form.type
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.startYear && !this.form.endYear) {
        this.$message.warning('请选择结束年份')
        return
      }
      if (this.form.startYear && this.form.endYear) {
        params.startYear = this.form.startYear
        params.endYear = this.form.endYear
      }
      if (this.form.tareWeightTime && this.form.tareWeightTime.length === 2) {
        params.tradeStartTime = this.form.tareWeightTime[0] + ' 00:00:00'
        params.tradeEndTime = this.form.tareWeightTime[1] + ' 23:59:59'
        console.log(params)
      }
      if (this.activeTab === 'yearStatistics') {
        delete params.tradeStartTime
        delete params.tradeEndTime
        delete params.type
      }
      let listFun = this.activeTab === 'yearStatistics' ? this.getRebateYearStatistics : this.rebateAccountDetailPage
      listFun(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.tableData = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 10
      this.form.type = ''
      this.form.startYear = ''
      this.form.endYear = ''
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    handleClose () {
      this.$router.go(-1)
    },
    handleExport () {
      this.exportRebateAccountDetail({ ...this.form, rebateAccountId: this.id }).then((res) => {
        function createDownloadFile () {
          let blob = new Blob([res])
          let link = document.createElement('a')
          link.download = '交易流水.xls'
          link.style.display = 'none'
          link.target = '_Blank'
          link.href = window.URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
        }
        createDownloadFile()
        this.$message.success('导出成功')
      })
    },
    handleTabClick (tab) {
      this.$nextTick(() => {
        this.handleSearch()
      })
    },
    handleStartChange (val) {
      if (!val) {
        this.form.endYear = ''
      }
      // 如果新选的开始年份大于当前结束年份，重置结束年份
      if (this.form.endYear && parseInt(val) > parseInt(this.form.endYear)) {
        this.form.endYear = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input, .form-select, .el-input-number {
  width: 200px;
}

.img-upload {
  height: 148px;
}
.form-title {
  font-weight: bold;
  margin-bottom: 20px;
}
.export-btn {
  float: right;
}
.separator {
  margin: 0 10px;
}
.year-picker {
  width: 150px !important;
}
</style>
